const MonitorRenderer = {
  renderCompactRow: function(article) {
    return $(article.card_html);
  },

  notFound: `<div class="tw-mx-auto tw-text-center tw-mt-[40px]" style="width: 340px">
    <img src="/static/img/monitor-not-found.svg" />
    <div class="tw-text-2xl tw-my-4">${window.JN.t('js.monitor.no_matches')}</div>
    <div class="tw-text-tertiary">${window.JN.t('js.monitor.no_matches_help')}</div>
  </div>`,

  dailyLimitExceeded: `<div class="tw-mx-auto tw-text-center tw-mt-[40px]" style="width: 340px">
    <img src="/static/img/monitor-not-found.svg" />
    <div class="tw-text-2xl tw-my-4">${window.JN.t('js.monitor.daily_limit_heading')}</div>
    <div class="tw-text-tertiary">${window.JN.t('js.monitor.daily_limit_help')}</div>
  </div>`
};


const SUMMARY_TYPE_MODES = [
  ['coverage_analysis', window.JN.t('js.monitor.mode_coverage_analysis')],
  ['trend_detection', window.JN.t('js.monitor.mode_trend_detection')],
  ['risk_intelligence', window.JN.t('js.monitor.mode_risk_intelligence')],
  ['journalist_research', window.JN.t('js.monitor.mode_journalist_research')],
];
const SUMMARY_TYPE_LABELS = Object.fromEntries(SUMMARY_TYPE_MODES);
const TAB_SPINNER = '<iconify-icon icon="svg-spinners:90-ring-with-bg" class="tw-text-xs tw-align-middle"></iconify-icon>';

function onPageLoad() {
  const $resultsContainer = $('#hits');
  const $noResults = $('#noresults');
  const $limitExceeded = $('#limit_exceeded');
  const $sentimentContainer = $('#sentiment-tab-content');
  const $sentimentProgress = $('#sentiment-progress');
  const $preloader = $('#preloader');

  // ============================================================================
  // Filter Management
  // ============================================================================

  const filters = {
    // Get current values from all filter controls
    getValues: function() {
      return {
        q: $('input[name=q]').val(),
        sentiment: $('select[name=sentiment]').val(),
        country: $('select[name=country]').val(),
        language: $('select[name=language]').val(),
        rank: $('select[name=rank]').val(),
        source: $('input[name=source]').val(),
        author: $('input[name=author]').val(),
        category: $('input[name=category]').val(),
        fromDate: $.datepicker.formatDate('yy-mm-dd', $('#from_date').datepicker('getDate')),
        toDate: $.datepicker.formatDate('yy-mm-dd', $('#to_date').datepicker('getDate')),
        summaryType: $('[name=summary_type]').val(),
        summarySize: $('select[name=summary_size]').val()
      };
    },

    // Build URL params from current filter values and search string
    buildParams: function(page) {
      const values = this.getValues();
      const pageLang = new URLSearchParams(window.location.search).get('lang');
      return new URLSearchParams({
        q: values.q,
        ...(pageLang && { lang: pageLang }),
        ...(values.sentiment && { sentiment: values.sentiment }),
        ...(values.country && { country: values.country }),
        ...(values.language && { language: values.language }),
        ...(values.rank && { rank: values.rank }),
        ...(values.source && { source: values.source }),
        ...(values.author && { author: values.author }),
        ...(values.category && { category: values.category }),
        ...(values.fromDate && { from_date: values.fromDate }),
        ...(values.toDate && { to_date: values.toDate }),
        ...(values.summaryType && { summary_type: values.summaryType }),
        ...(values.summarySize && { summary_size: values.summarySize }),
        ...(page && { page })
      });
    },

    // Sync filter values to alert form hidden inputs
    syncToAlertForm: function() {
      const values = this.getValues();
      $('input[name=name_tx]').val(values.q);
      $('input[name=query_tx]').val(values.q);
      $('input[name=sentiment]').val(values.sentiment);
      $('input[name=language_cd]').val(values.language);
      $('input[name=country_cd]').val(values.country);
      $('input[name=source_tx]').val(values.source || '');
      $('input[name=rank_cd]').val(values.rank);
      $('input[name=summary_type_cd]').val(values.summaryType || '');
      $('input[name=summary_size_int]').val(values.summarySize || '50');
    },

    // Count number of active filters
    countActive: function() {
      const values = this.getValues();
      let count = 0;
      if (values.sentiment) count++;
      if (values.language) count++;
      if (values.country) count++;
      if (values.rank) count++;
      if (values.fromDate) count++;
      if (values.toDate) count++;
      return count;
    },

    // Reset all filters to default state
    reset: function(sourceSearchInstance) {
      $('input[name=q]').val('');
      $('select[name=sentiment]').val('').change();
      $('select[name=language]').val('').change();
      $('select[name=country]').val('').change();
      $('select[name=rank]').val('').change();
      if (sourceSearchInstance) {
        sourceSearchInstance.clear();
      }
      $('input[name=author]').val('');
      $('.author-input').val('');
      $('.author-filter').hide();
      $('input[name=category]').val('');
      $('[name=summary_type]').val('coverage_analysis');
      $('select[name=summary_size]').val('25').change();
      $('#date-auto-note').addClass('tw-hidden');
      $('.quickdate #days-auto').prop('checked', true).change();
    },
  };

  // ============================================================================
  // Source Search
  // ============================================================================

  const sourceSearch = new SourceSearch({
    container: '.source-search',
    onSelect: function(id, name) {
      // Reset country, language, and rank filters when source is set
      $('select[name=country]').val('').change();
      $('select[name=language]').val('').change();
      $('select[name=rank]').val('').change();
    }
  });

  // ============================================================================
  // Author Filter
  // ============================================================================

  const $authorFilter = $('.author-filter');
  const $authorInput = $('.author-input');
  const $authorHidden = $('input[name=author]');
  const $authorInputClear = $('.author-input-clear');

  function setAuthor(name) {
    $authorHidden.val(name);
    $authorInput.val(name);
    $authorFilter.show();
    $authorFilter.closest('details').prop('open', true);
  }

  function clearAuthor() {
    $authorHidden.val('');
    $authorInput.val('');
    $authorFilter.hide();
  }

  $authorInputClear.on('click', function() {
    clearAuthor();
    applyFilters();
  });

  // ============================================================================
  // Date Controls
  // ============================================================================

  const minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - 10);

  $('#from_date, #to_date').datepicker({
    dateFormat: 'd M yy',
    changeMonth: true,
    changeYear: true,
    minDate: minDate,
    maxDate: new Date(),
    onSelect: function() {
      const hasDate = $('#from_date').val() || $('#to_date').val();
      $('.dates-clear').toggle(!!hasDate);
    }
  });

  function updateDateControls(fromDate, toDate) {
    // In "Best match" mode, don't flip the pill to the server-chosen window; the
    // sidebar note reports it instead (derived from allWindow).
    if ($('#days-auto').prop('checked')) return;

    $('#from_date').datepicker('setDate', fromDate);
    $('#to_date').datepicker('setDate', toDate);

    if (fromDate || toDate) {
      $('.dates-clear').show();
    } else {
      $('.dates-clear').hide();
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const effectiveToDate = toDate || today;

    if (fromDate && effectiveToDate >= today) {
      const diffMs = effectiveToDate - fromDate;
      const diffDays = Math.max(1, Math.round(diffMs / (1000 * 60 * 60 * 24)));
      let dateItem = $(`#days-${diffDays}`);
      if (!dateItem.length) {
        dateItem = $(`#days-custom`);
      }
      dateItem.prop('checked', true).trigger('change');
    } else if (fromDate || toDate) {
      $(`#days-custom`).prop('checked', true).trigger('change');
    }
  }

  function initializeDatesFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search);
      const fromDateStr = params.get('from_date');
      const toDateStr = params.get('to_date');
      const fromDate = fromDateStr ? new Date(fromDateStr) : null;
      const toDate = toDateStr ? new Date(toDateStr) : null;
      // An explicit date in the URL is a real range, not "Best match" — uncheck auto
      // so updateDateControls applies it (auto mode early-returns).
      if (fromDate || toDate) {
        $('#days-auto').prop('checked', false);
        $('#date-auto-note').addClass('tw-hidden');
      }
      updateDateControls(fromDate, toDate);
    } catch (e) {
      console.error('Error initializing dates from URL:', e);
    }
  }

  // ============================================================================
  // Search State & Logic
  // ============================================================================

  let ndSearchRequest = null;
  let summaryRequest = null;   // AbortController for the in-flight summary fetch
  let searchSeq = 0;          // bumped per search; stale responses are ignored
  let searchesCount = 0;
  let page = 1;
  let loadedArticles = 0;
  let foundArticles = 0;
  let isLoading = false;
  let stopSearch = false;
  let stopLoadingStats = false;
  let lastSearchResultDiv = null;
  let currentArticles = [];
  let currentRelevant = [];      // relevant set in memory, for the tab-aware CSV download
  let currentRecommended = [];   // recommended set in memory, for the tab-aware CSV download
  let summaryStats = { found: 0, corpus: 0, relevant: 0 };
  let aiNotes = {};
  // Each tab's data for the glance strip, recomputed so the chart + outlets reflect
  // only the articles in the active tab. allWindow pins the chart x-axis to the full
  // searched window so all tabs share one axis and gaps in coverage show accurately.
  let tabDatasets = { all: null, relevant: null, recommended: null };
  let allWindow = null;   // {min, max} epoch-seconds of the searched window
  let glanceChart = null;

  function currentResultsTab() {
    return ($('#results-tabs input:checked').attr('id') || 'rtab-all').replace('rtab-', '');
  }

  // Tab-aware CSV link: the count is what will actually download. All exports the cached corpus
  // (capped at monitorCorpusCap; shown as "N of M" when fewer than found); Relevant the full
  // triaged set; Recommended the in-memory set. The link hides when the active tab is empty, and
  // never shows on the no-query "Latest news" feed. No-op when absent (anonymous users).
  function updateDownloadLink() {
    const $link = $('#download-csv');
    if (!$link.length) return;
    if (!filters.getValues().q) { $link.addClass('tw-hidden'); return; }
    const tab = currentResultsTab();
    let label = '';
    if (tab === 'all') {
      const found = foundArticles || 0;
      const n = summaryStats.corpus || Math.min(found, monitorCorpusCap);
      if (n) label = found > n ? `(${n} of ${found})` : `(${n})`;
    } else if (tab === 'relevant') {
      const n = summaryStats.relevant || currentRelevant.length;
      if (n) label = `(${n})`;
    } else if (tab === 'recommended') {
      if (currentRecommended.length) label = `(${currentRecommended.length})`;
    }
    $('#csv-count').text(label);
    $link.toggleClass('tw-hidden', !label);
  }

  function csvCell(value) {
    const s = String(value == null ? '' : value);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  }

  // Build a CSV from a client-side article set (Relevant/Recommended) and trigger a download.
  // Mirrors the server's download_csv columns and dd/mm/YYYY date so all three tabs match.
  function downloadClientCsv(articles) {
    const q = filters.getValues().q || 'monitor';
    const filename = (q.replace(/[^0-9A-Za-z]+/g, '_').replace(/^_+|_+$/g, '') || 'monitor') + '.csv';
    const rows = [['Publication', 'Published', 'Author', 'Title', 'URL']];
    (articles || []).forEach(a => {
      const publication = a.property_name || a.source_outlet || '';
      let published = '';
      if (a.publish_date) {
        const d = new Date(a.publish_date * 1000);
        published = `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
      } else {
        published = a.friendly_date || '';
      }
      const author = [a.first_name, a.last_name].filter(Boolean).join(' ');
      rows.push([publication, published, author, a.title || '', a.url || '']);
    });
    const csv = '﻿' + rows.map(r => r.map(csvCell).join(',')).join('\n');
    const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  function windowLabelFromSpan(secs) {
    const d = Math.max(1, Math.round(secs / 86400));
    if (d <= 1) return window.JN.t('js.monitor.window_24h');
    if (d <= 10) return window.JN.t('js.monitor.window_7d');
    if (d <= 40) return window.JN.t('js.monitor.window_28d');
    return window.JN.t('js.monitor.window_n_days').replace('%s', d);
  }

  // Authoritative window label from the planner, so the sidebar caption, chart header and
  // loading check all agree (windowLabelFromSpan buckets too coarsely to trust on its own).
  function planWindowLabel(plan) {
    const d = (plan && plan.window_days) || 1;
    return d <= 1 ? window.JN.t('js.monitor.window_24h') : window.JN.t('js.monitor.window_n_days').replace('%s', d);
  }

  // Keep the date-filter caption a quiet, short window label; the chosen window is shown
  // prominently as the first loading stage instead (see renderLoadingState).
  function renderSearchPlanNote(plan, windowLabel) {
    $('#date-auto-note').removeClass('tw-hidden').text(window.JN.t('js.monitor.auto_showing').replace('%s', windowLabel));
  }

  // Publication name → NewsAPI source id, harvested from rendered articles so that
  // clicking an outlet name (in a row or the Top-outlets card) can scope the search.
  let sourceIdByName = {};
  function indexSourceIds(articles) {
    (articles || []).forEach(a => {
      const name = a.property_name || a.source_outlet;
      if (name && a.source_id) sourceIdByName[name] = a.source_id;
    });
  }

  function filterToSource(sourceId, sourceName) {
    sourceSearch.select(sourceId, sourceName);
    applyFilters();
  }

  function renderActiveFilters() {
    const chips = [];
    const src = sourceSearch.getValue();
    if (src && src.name) {
      chips.push({ label: src.name, icon: 'lucide:newspaper', clear: 'source' });
    }
    const author = $('input[name=author]').val();
    if (author) chips.push({ label: author, icon: 'mage:user', clear: 'author' });

    const $f = $('#active-filters');
    if (!chips.length) { $f.addClass('tw-hidden').empty(); return; }
    $f.removeClass('tw-hidden').html(
      `<span class="tw-text-xs tw-text-tertiary">${window.JN.t('js.monitor.filtered_to')}</span>` +
      chips.map(c => `
        <button type="button" data-clear="${c.clear}" class="active-filter-chip tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-bg-brand-50 tw-text-brand-700 tw-border tw-border-brand-200 tw-px-3 tw-py-1 tw-text-sm">
          <iconify-icon icon="${c.icon}"></iconify-icon>
          <span>${escapeHtml(c.label)}</span>
          <iconify-icon icon="basil:cross-outline" class="tw-text-base"></iconify-icon>
        </button>`).join('')
    );
    $f.find('.active-filter-chip').on('click', function() {
      if ($(this).data('clear') === 'source') sourceSearch.clear();
      else clearAuthor();
      applyFilters();
    });
  }

  function computeStatsFromArticles(articles, count) {
    const stats = { positive: {}, neutral: {}, negative: {} };
    const points = [];
    (articles || []).forEach(a => {
      const src = a.property_name || a.source_outlet;
      const sent = a.sentiment && stats[a.sentiment] ? a.sentiment : 'neutral';
      if (src) stats[sent][src] = (stats[sent][src] || 0) + 1;
      if (a.publish_date) points.push({ d: a.publish_date, s: sent });
    });
    return { stats, points, count: count || (articles || []).length };
  }

  function renderGlanceFor(tabName) {
    if (anonymous) return;
    const ds = tabDatasets[tabName];
    const html = ds ? renderGlanceStrip(ds) : '';
    if (!html) {
      if (glanceChart) { glanceChart.destroy(); glanceChart = null; }
      $('#glance-strip').addClass('tw-hidden').empty();
      return;
    }
    $('#glance-strip').removeClass('tw-hidden').html(html);
    renderGlanceChart(ds);
    $('#glance-expand').on('click', expandRange);
    $('#glance-strip .outlet-filter').on('click', function() {
      filterToSource($(this).data('source-id'), $(this).data('source-name'));
    });
    // The LLM facet notes describe the relevant set, so only attach them there.
    if (tabName === 'relevant') {
      const chartNote = [aiNotes.volume, aiNotes.sentiment].filter(Boolean).join(' ');
      if (chartNote) $('#note-chart').html(aiNote(chartNote));
      if (aiNotes.outlets) $('#note-outlets').html(aiNote(aiNotes.outlets));
    }
  }

  // Source and author on a news card filter the list; the card itself opens in the work modal.
  $('#hits, #hits-relevant, #recommended-reading').on('click', '.article-source, .article-author', function() {
    const $src = $(this);
    if ($src.hasClass('article-source')) sourceSearch.select($src.data('source-id'), $src.data('source-name'));
    else setAuthor($src.data('author'));
    applyFilters();
  });

  $('#sentiment-tab-content').on('click', '.theme-source', function(e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    window.JN.workModal.openUrl(this.href);
  });

  function renderRelevantList(articles) {
    currentRelevant = articles || [];
    const $rel = $('#hits-relevant').empty();
    currentRelevant.forEach(item => {
      $rel.append(MonitorRenderer.renderCompactRow(item));
    });
    const has = currentRelevant.length > 0;
    $('#relevant-empty').toggleClass('tw-hidden', has);
    if (!has) $('#relevant-empty').text(window.JN.t('js.monitor.no_relevant'));
    $('#tab-count-relevant').text(summaryStats.relevant ? `(${summaryStats.relevant})` : '');
    updateDownloadLink();
  }

  let resultsTabsTouched = false;

  function selectResultsTab(name) {
    $(`#rtab-${name}`).prop('checked', true);
    renderGlanceFor(name);
    updateDownloadLink();
  }

  // All results shows immediately on every search; the Relevant/Recommended tabs only
  // exist once an AI pass runs (signed-in user with a query) and the UI switches to
  // Relevant when the summary lands. No-query/anonymous get the chronological list only.
  function configureResultsTabs(hasQuery) {
    // Anonymous users keep all three tabs; the Relevant/Recommended panels show the signup
    // gate instead of content (rendered server-side in the template).
    const showAiTabs = hasQuery;
    $('label[for=rtab-relevant], label[for=rtab-recommended]').toggleClass('tw-hidden', !showAiTabs);
    $('#tab-label-all').text(hasQuery ? window.JN.t('js.monitor.tab_all_results') : window.JN.t('js.monitor.tab_latest_news'));
    resultsTabsTouched = false;
    selectResultsTab('all');
  }

  function setResultCount(count) {
    const cnt = count || 0;
    const articleWord = cnt === 1 ? window.JN.t('js.monitor.article_one') : window.JN.t('js.monitor.article_many');
    $('.result-counter').html(`
      <span>${cnt} ${articleWord}</span>
      <span class="tw-text-tertiary">${window.JN.t('js.monitor.match_criteria')}</span>
    `);
  }

  function updateResultCount() {
    if (anonymous || !summaryStats.relevant) return;
    const found = summaryStats.found || foundArticles || 0;
    const articleWord = found === 1 ? window.JN.t('js.monitor.article_one') : window.JN.t('js.monitor.article_many');
    $('.result-counter').html(`
      <span>${found} ${articleWord}</span>
      <span class="tw-text-tertiary">${window.JN.t('js.monitor.ai_filtered_to').replace('%s', summaryStats.relevant)}</span>
    `);
  }

  function initSearch() {
    page = 1;
    loadedArticles = 0;
    foundArticles = 0;
    isLoading = false;
    stopSearch = false;
    stopLoadingStats = true;
    searchSeq += 1;
    clearTimeout(summaryDebounce);
    ndSearchRequest?.abort();
    summaryRequest?.abort();
    stopSummaryStages();
    lastSearchResultDiv = null;
    currentArticles = [];
    currentRelevant = [];
    currentRecommended = [];
    $('#download-csv').addClass('tw-hidden');
    lastSearchPlan = null;  // don't show the previous search's window on the new loading card
    $resultsContainer.html('');
    $noResults.addClass('tw-hidden');
    $('#glance-strip').addClass('tw-hidden').empty();
    summaryStats = { found: 0, corpus: 0, relevant: 0 };
    aiNotes = {};
    tabDatasets = { all: null, relevant: null, recommended: null };
    allWindow = null;
    if (glanceChart) { glanceChart.destroy(); glanceChart = null; }
    $('#hits-relevant').empty();
    $('#recommended-reading').empty();
    $('#relevant-empty').removeClass('tw-hidden').text(window.JN.t('js.monitor.finding_relevant'));
    $('#recommended-empty').removeClass('tw-hidden');
    $('#tab-count-relevant, #tab-count-all, #tab-count-recommended').text('');
    $('#all-gate, #limit_exceeded').addClass('tw-hidden');  // reset anonymous gates between searches
    $('#results-tabs').addClass('tw-hidden');
    const hasQuery = !!filters.getValues().q;
    configureResultsTabs(hasQuery);
    if (hasQuery) {
      $('#first-run').hide();
      $('#mobile-monitor-nav').addClass('compact');
    } else {
      $('#first-run').show();
      $('#mobile-monitor-nav').removeClass('compact');
    }
    $('#mobile-quick-search input[name=q]').val(filters.getValues().q || '');
    if (anonymous || !hasQuery) {
      $sentimentContainer.addClass('tw-hidden').empty();
    } else {
      $sentimentContainer.removeClass('tw-hidden').html(renderLoadingState());
      bindCardHeader();
      startSummaryStages();
    }
    $sentimentProgress.addClass('tw-hidden');
    $limitExceeded.addClass('tw-hidden');
    $('#maxresults').addClass('tw-hidden');
    $('.content-action-button').addClass('tw-hidden');
    $('.result-counter').html(window.JN.t('js.monitor.searching'));
    searchesCount += 1;
  }

  function doSearch() {
    if (isLoading || stopSearch) return;

    isLoading = true;
    $preloader.removeClass('tw-hidden');
    $noResults.addClass('tw-hidden');
    $('#content-wrapper').removeClass('tw-hidden');
    $('#page-empty').addClass('tw-hidden');

    const params = filters.buildParams(page);
    filters.syncToAlertForm();

    if (!ndSearchRequest) {
      ndSearchRequest = new AbortController();
    }

    window.JN.xsrf.fetch('?' + params.toString(), {
      method: 'POST',
      signal: ndSearchRequest.signal
    })
      .then(async (response) => {
        let result = await response.text();
        try { result = JSON.parse(result); } catch (_) {}

        if (response.ok) {
          handleSearchSuccess(result, params);
        } else {
          throw new Error(result?.message || result);
        }
        page++;
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
          console.log(error.message, error.stack);
          const message = `${window.JN.t('js.monitor.error_prefix')} ${error.message}`;
          if (page === 1) {
            // the results tabs stay hidden until a search succeeds
            $noResults.text(message).removeClass('tw-hidden');
            $sentimentContainer.addClass('tw-hidden').empty();
          } else {
            $resultsContainer.append($('<div>').text(message));
          }
        }
      })
      .finally(() => {
        isLoading = false;
        $preloader.addClass('tw-hidden');
        ndSearchRequest = null;
      });
  }

  function handleSearchSuccess(result, params) {
    // Update URL without page param
    params.delete('page');
    history.pushState('', document.title, window.location.toString().split('?')[0] + '?' + params.toString());

    $('.result-counter').html('');

    if (result.articles?.length > 0) {
      handleArticlesFound(result);
    } else if (result?.message === 'daily_limit_exceeded') {
      handleDailyLimitExceeded();
    } else if (result?.message === 'limit_exceeded') {
      stopSearch = true;
      $limitExceeded.removeClass('tw-hidden');
    } else {
      handleNoResults(result.found_articles);
    }
  }

  function handleArticlesFound(result) {
    const searchString = filters.getValues().q;
    if (page === 1) {
      foundArticles = result.found_articles;
      loadedArticles = result.articles.length;
      currentArticles = result.articles;
      lastSearchPlan = result.search_plan || null;
      stopLoadingStats = false;

      // If source filter is active, show source name from first article
      const currentSource = filters.getValues().source;
      if (currentSource && result.articles.length > 0 && !sourceSearch.getValue().name) {
        const sourceName = result.articles[0].property_name;
        if (sourceName) {
          sourceSearch.setValue(currentSource, sourceName);
        }
      }

      indexSourceIds(result.articles);
      renderActiveFilters();
      if (searchString && !anonymous && result.stats) {
        const points = result.points || [];
        tabDatasets.all = { stats: result.stats, points: points, count: result.found_articles };
        // Pin the chart axis to the full searched window (from_date → to_date, or → now
        // when no end date), so every tab shares one axis and gaps in coverage show.
        const fromEpoch = result.from_date ? Date.parse(result.from_date) / 1000 : NaN;
        const toVal = filters.getValues().toDate;
        const toEpoch = toVal ? Date.parse(toVal + 'T23:59:59Z') / 1000 : NaN;
        const maxEpoch = !isNaN(toEpoch) ? toEpoch : Date.now() / 1000;
        if (!isNaN(fromEpoch) && fromEpoch < maxEpoch) {
          allWindow = { min: fromEpoch, max: maxEpoch };
        } else {
          const ds = points.map(p => p.d).filter(Boolean);
          allWindow = ds.length >= 2 ? { min: Math.min(...ds), max: Math.max(...ds) } : null;
        }
        // Single source of truth for the window caption (chart + sidebar note + meta).
        if (allWindow) {
          summaryStats.windowLabel = result.search_plan
            ? planWindowLabel(result.search_plan)
            : windowLabelFromSpan(allWindow.max - allWindow.min);
          if ($('#days-auto').prop('checked')) {
            renderSearchPlanNote(result.search_plan, summaryStats.windowLabel);
          }
        }
        renderGlanceFor(currentResultsTab());
      }

      if (searchString) {
        if (anonymous) {
          saveResume(filters.getValues());
          loadTeaser(filters.buildParams(page));
        } else {
          scheduleSummary(filters.buildParams(page));
        }
        //addSearchToHistory();
        $('.content-action-button').removeClass('tw-hidden');
      } else {
        $('#create-alert').addClass('tw-hidden');
      }
      if (anonymous) {
        // Page 1 is all anonymous users get (search or latest-news feed): show the gate
        // inline now and stop, so the infinite-scroll skeleton never fires a page-2 fetch
        // the server would only reject.
        stopSearch = true;
        $preloader.addClass('tw-hidden');
        $('#all-gate').removeClass('tw-hidden');
      }
      if (searchesCount > 1) {
        $('#last_searches').hide();
      }
    }

    if (searchString) {
      setResultCount(foundArticles);
    } else {
      $('.result-counter').text(searchString || window.JN.t('js.monitor.latest_news_caption'));
    }

    $(`select[name=country] option[value="${result.country || ''}"]`).attr('selected', 'selected');

    const fromDateFromServer = result.from_date ? new Date(result.from_date) : null;
    const currentToDate = $('#to_date').datepicker('getDate');
    updateDateControls(fromDateFromServer, currentToDate);

    $('#results-tabs').removeClass('tw-hidden');
    if (searchString) {
      $('#tab-count-all').text(`(${foundArticles || result.articles.length})`);
    }
    updateDownloadLink();

    result.articles.forEach(item => {
      $resultsContainer.append(MonitorRenderer.renderCompactRow(item));
    });

    $noResults.addClass('tw-hidden');
    $resultsContainer.removeClass('tw-hidden');
    lastSearchResultDiv = $resultsContainer[0].lastElementChild;
  }

  function handleDailyLimitExceeded() {
    stopSearch = true;
    if (anonymous) {
      $sentimentContainer.addClass('tw-hidden');
      $('.free_signup_title').text(window.JN.t('js.monitor.anon_daily_limit_title'));
      $('.free_signup_text').text(window.JN.t('js.monitor.anon_daily_limit_text'));
      $('.search_limit').addClass('tw-hidden');
      $('.search_limit_daily').removeClass('tw-hidden');
    } else {
      $limitExceeded[0].innerHTML = MonitorRenderer.dailyLimitExceeded;
    }
    $limitExceeded.removeClass('tw-hidden');
  }

  function handleNoResults(foundArticles) {
    stopSearch = true;
    if (page === 1) {
      $noResults[0].innerHTML = MonitorRenderer.notFound;
      $noResults.removeClass('tw-hidden');
      $resultsContainer.addClass('tw-hidden');
      $sentimentContainer.addClass('tw-hidden').empty();
    } else if (parseInt(foundArticles) > resultsLimit) {
      $('#maxresults').removeClass('tw-hidden');
    }
  }

  // ============================================================================
  // Statistics Loading
  // ============================================================================

  // The article fetch is cheap (1 token) but the briefing is an expensive LLM call.
  // Debounce it so a flurry of filter changes only fires one deep-read — aborting the
  // client fetch alone wouldn't stop the server-side LLM work, so we avoid starting it.
  let summaryDebounce = null;
  function scheduleSummary(params) {
    clearTimeout(summaryDebounce);
    summaryDebounce = setTimeout(() => loadBriefing(params), 500);
  }

  // The briefing loads in two phases so the Relevant tab fills in before the (slower)
  // prose is written: phase 1 (/triage) returns the relevant set, phase 2 (/summary)
  // deep-reads it into the briefing + recommended reading.
  // Paint the Phase-1 picture from the triage stage: the All-results glance (a true
  // superset of Relevant) and the Relevant tab list.
  function renderTriage(triage) {
    if (triage.corpus_articles && triage.corpus_articles.length) {
      indexSourceIds(triage.corpus_articles);   // so Top-outlets names are clickable
      tabDatasets.all = computeStatsFromArticles(triage.corpus_articles, triage.found || foundArticles || 0);
      // We pull at most MAX_CORPUS (newest-first). When the result set is larger, we
      // couldn't measure the oldest part of the window — so cap the axis to the span we
      // actually sampled rather than show false-empty time we never looked at.
      if (triage.found > triage.corpus_count && allWindow) {
        const cpts = triage.corpus_articles.map(a => a.publish_date).filter(Boolean);
        if (cpts.length) {
          allWindow = { min: Math.min(...cpts), max: allWindow.max };
          summaryStats.windowLabel = windowLabelFromSpan(allWindow.max - allWindow.min);
        }
      }
      renderGlanceFor(currentResultsTab());
    }
    if (triage.relevant_count > 0) {
      summaryStats = { ...summaryStats, found: triage.found || foundArticles || 0,
        corpus: triage.corpus_count || 0, relevant: triage.relevant_count || 0 };
      const relevantArticles = triage.relevant_articles || [];
      indexSourceIds(relevantArticles);
      renderRelevantList(relevantArticles);               // fills count, clears the spinner
      tabDatasets.relevant = computeStatsFromArticles(relevantArticles, summaryStats.relevant);
      updateResultCount();
      if (!resultsTabsTouched) selectResultsTab('relevant');  // auto-switch to Relevant
      else renderGlanceFor(currentResultsTab());
      setSummaryStage(3);                                  // hand the spinner to Recommended
      $('#recommended-empty').addClass('tw-hidden');
      $('#tab-count-recommended').html(TAB_SPINNER);
    } else {
      // 0 relevant: nothing for the Relevant tab; the coverage card paints the empty state.
      summaryStats = { ...summaryStats, found: triage.found || foundArticles || 0,
        corpus: triage.corpus_count || 0, relevant: 0 };
      $('#tab-count-relevant').text('');
      setSummaryStage(3);
    }
  }

  // The corpus+triage and the ~16s deep-read run on two chained /q worker queues; POST
  // enqueues and we poll the staged result (triaged -> Success), so the web thread is
  // never blocked. searchSeq rejects a poll once a newer search has started.
  async function loadBriefing(initialParams, opts = {}) {
    const seq = searchSeq;
    $sentimentProgress.addClass('tw-hidden');
    $sentimentContainer.removeClass('tw-hidden').html(renderLoadingState());
    bindCardHeader();
    summaryRequest?.abort();
    summaryRequest = new AbortController();
    const signal = summaryRequest.signal;
    setSummaryStage(opts.briefingOnly ? 3 : 2);   // briefingOnly: relevant set already shown
    if (!opts.briefingOnly) $('#tab-count-relevant').html(TAB_SPINNER);

    const url = '/a/monitor/summary?' + initialParams.toString();
    const fail = () => { if (seq === searchSeq) drawChartAndStats({ status: 'Failed', reason: 'Could not reach the summary service.' }); };
    const deadline = Date.now() + 300000;  // backstop only: the workers fail fast within their stage budgets
    let method = 'POST';                    // first call enqueues; then poll with GET
    let triageShown = false, reposted = false;

    while (true) {
      let data;
      try {
        data = await window.JN.xsrf.fetch(url, { method, signal }).then(res => res.json());
      } catch (err) {
        if (err.name === 'AbortError' || seq !== searchSeq) return;
        return fail();
      }
      if (seq !== searchSeq) return;   // a newer search superseded this one
      const status = data && data.status;
      if (status === 'pending' || status === 'triaged') {
        if (status === 'triaged' && !opts.briefingOnly && !triageShown) { renderTriage(data); triageShown = true; }
        if (Date.now() > deadline) return fail();
        method = 'GET';
        await new Promise(r => setTimeout(r, 2000));
        if (seq !== searchSeq) return;
        continue;
      }
      if (status === 'expired') {   // the pending sentinel lapsed: re-enqueue once
        if (reposted) return fail();
        reposted = true; method = 'POST';
        continue;
      }
      // terminal (Success / Failed). Paint the relevant set too if we never saw 'triaged'
      // (the local sync path returns the finished briefing in one shot).
      if (!opts.briefingOnly && !triageShown && data && data.corpus_articles) renderTriage(data);
      drawChartAndStats(data);
      return;
    }
  }

  // Logged-out preview: run the same four-stage loading checklist as the signed-in briefing,
  // then ask the (cheap, server-truncated) summary endpoint for a real headline + opening
  // lines and show them behind a signup lock. The gated body is never sent to the client.
  async function loadTeaser(params) {
    const seq = searchSeq;
    $sentimentProgress.addClass('tw-hidden');
    $sentimentContainer.removeClass('tw-hidden').html(renderTeaserLoading());
    startSummaryStages();
    summaryRequest?.abort();
    summaryRequest = new AbortController();
    // One cheap call backs the teaser; advance the visible stages on a light timer so the
    // checklist reads like the real briefing rather than one opaque spinner.
    const s2 = setTimeout(() => { if (seq === searchSeq) setSummaryStage(2); }, 900);
    const s3 = setTimeout(() => { if (seq === searchSeq) setSummaryStage(3); }, 2200);
    let data;
    try {
      const res = await window.JN.xsrf.fetch('/a/monitor/summary?' + params.toString(),
        { method: 'POST', signal: summaryRequest.signal });
      data = await res.json();
    } catch (err) {
      clearTimeout(s2); clearTimeout(s3);
      if (err.name === 'AbortError') return;
      data = null;
    }
    clearTimeout(s2); clearTimeout(s3);
    if (seq !== searchSeq) return;
    if (data && data.message === 'daily_limit_exceeded') return handleDailyLimitExceeded();
    setSummaryStage(4);
    $sentimentContainer.html(renderTeaserCard(data));
  }

  // Same four-stage checklist as the signed-in briefing (summary-stage rows so setSummaryStage
  // can advance them), with a lightweight header instead of the alert/share actions.
  function renderTeaserLoading() {
    const stages = [dateRangeStageLabel(), window.JN.t('js.monitor.stage_scanning'), window.JN.t('js.monitor.stage_finding'), window.JN.t('js.monitor.stage_writing')];
    const rows = stages.map(s => `
      <div class="summary-stage tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-tertiary">
        <iconify-icon icon="lucide:circle" class="tw-text-tertiary"></iconify-icon>
        <span>${escapeHtml(s)}</span>
      </div>`).join('');
    return `
      <div class="tw-flex tw-items-center tw-gap-2">
        <iconify-icon icon="humbleicons:ai" class="tw-text-2xl tw-text-brand-600"></iconify-icon>
        <span class="tw-font-normal tw-text-lg">${window.JN.t('js.monitor.ai_briefing')}</span>
      </div>
      <div class="tw-flex tw-flex-col tw-gap-2 tw-py-1">${rows}</div>
      <div class="tw-text-xs tw-text-tertiary">${window.JN.t('js.monitor.teaser_timing')}</div>`;
  }

  function renderTeaserCard(data) {
    const ok = data && data.status === 'Success';
    const title = ok && data.title ? data.title : window.JN.t('js.monitor.teaser_title_fallback');
    const snippet = ok && data.overview_snippet
      ? data.overview_snippet
      : window.JN.t('js.monitor.teaser_snippet_fallback');
    return `
      <div class="tw-text-xs tw-font-medium tw-tracking-wide tw-text-brand-700">${window.JN.t('js.monitor.teaser_badge')}</div>
      <div class="tw-text-2xl md:tw-text-3xl">${escapeHtml(title)}</div>
      <div class="tw-relative">
        <p class="tw-text-secondary-text tw-leading-relaxed">${escapeHtml(snippet)}</p>
        <div class="tw-mt-2 tw-space-y-2" aria-hidden="true">
          <div class="tw-h-3 tw-bg-grey tw-rounded tw-w-11/12"></div>
          <div class="tw-h-3 tw-bg-grey tw-rounded tw-w-8/12"></div>
        </div>
        <div class="tw-pointer-events-none tw-absolute tw-inset-x-0 tw-bottom-0 tw-h-20 tw-bg-gradient-to-t tw-from-white tw-to-transparent"></div>
      </div>
      <div class="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center tw-gap-3">
        <a class="btn big tw-whitespace-nowrap" onclick="showRegisterMessageDialog('#register_monitor_form');">${window.JN.t('js.monitor.unlock_briefing')}
          <iconify-icon icon="lucide:lock" class="tw-bg-white tw-h-[32px] tw-w-[32px] tw-flex tw-items-center tw-justify-center tw-rounded-full tw-text-brand-600 tw-text-lg"></iconify-icon>
        </a>
        <span class="tw-text-sm tw-text-tertiary">${window.JN.t('js.monitor.unlock_free_note')}</span>
      </div>`;
  }

  // Resume: remember a logged-out visitor's last search so that, once they register and
  // sign in on this browser, /monitor can offer to pick up where they left off. Survives
  // the session_id swap at login (localStorage, not the session cookie).
  const RESUME_KEY = 'monitor_resume';
  function saveResume(values) {
    if (!values || !values.q) return;
    try { localStorage.setItem(RESUME_KEY, JSON.stringify({ q: values.q, summaryType: values.summaryType })); }
    catch (e) { /* private mode / quota — resume is best-effort */ }
  }
  function loadResume() {
    try { return JSON.parse(localStorage.getItem(RESUME_KEY) || 'null'); }
    catch (e) { return null; }
  }
  function renderResumeChip(saved) {
    const $row = $('#first-run .tw-flex.tw-flex-wrap');
    if (!$row.length) return;
    const $chip = $(`<a class="tw-cursor-pointer tw-bg-brand-600 hover:tw-bg-brand-700 tw-rounded-full tw-px-4 tw-py-2 tw-text-sm tw-inline-flex tw-items-center tw-gap-2 !tw-text-white !tw-no-underline tw-transition-colors">
      <iconify-icon icon="hugeicons:time-quarter-pass"></iconify-icon> ${window.JN.t('js.monitor.resume')} <span class="tw-font-medium">${escapeHtml(saved.q)}</span></a>`);
    $chip.on('click', function() {
      $('#search-form input[name=q]').val(saved.q);
      if (saved.summaryType) $('[name=summary_type]').val(saved.summaryType);
      $('#search-form').submit();
    });
    $row.prepend($chip);
  }

  function drawChartAndStats(summary) {
    const summaryType = $('[name=summary_type]').val();
    stopSummaryStages();
    $('#glance-strip .glance-note').empty();

    if (summary) {
      summaryStats = {
        ...summaryStats,
        found: summary.found || foundArticles || 0,
        corpus: summary.corpus_count || 0,
        relevant: summary.relevant_count || 0,
      };
      const relevantArticles = summary.relevant_articles || [];
      const recommendedArticles = (summary.recommended_reading || []).filter(r => r && r.url && r.title);
      indexSourceIds(relevantArticles);
      indexSourceIds(recommendedArticles);
      renderRelevantList(relevantArticles);
      renderRecommendedReading(recommendedArticles);   // phase 2 has landed; clears its spinner
      aiNotes = { volume: summary.volume_note, sentiment: summary.sentiment_note, outlets: summary.outlets_note };
      tabDatasets.relevant = computeStatsFromArticles(relevantArticles, summaryStats.relevant);
      tabDatasets.recommended = computeStatsFromArticles(recommendedArticles, recommendedArticles.length);
      updateResultCount();
      // Reveal the filtered Relevant view once it's ready (unless the user already
      // picked a tab). On 0 relevant this shows the clean empty state + blank chart,
      // with All (N) one click away.
      if (!resultsTabsTouched) selectResultsTab('relevant');
      else renderGlanceFor(currentResultsTab());
    }

    if (!summary || summary.status !== 'Success' || !summary.title) {
      $sentimentContainer.html(renderEmptyState(summary || {}));
      bindCardHeader();
      $sentimentContainer.find('.empty-action').on('click', function() {
        const a = $(this).data('empty');
        if (a === 'widen') expandRange();
        else if (a === 'anycountry') { $('select[name=country]').val('').change(); applyFilters(); }
        else if (a === 'seeall') selectResultsTab('all');
        else loadBriefing(filters.buildParams(1));
      });
      return false;
    }

    if (summaryType === 'coverage_analysis') {
      $sentimentContainer.html(renderCoverageAnalysisCard(summary, currentArticles, loadedArticles));
      if (summary.volume_note) $('#note-volume').html(aiNote(summary.volume_note));
      if (summary.sentiment_note) $('#note-sentiment').html(aiNote(summary.sentiment_note));
      if (summary.outlets_note) $('#note-outlets').html(aiNote(summary.outlets_note));
    } else {
      $sentimentContainer.html(renderLegacySummary(summary));
    }
    bindCardHeader();
    return true;
  }

  function renderRecommendedReading(items) {
    currentRecommended = items || [];
    const $rr = $('#recommended-reading').empty();
    currentRecommended.forEach(r => $rr.append(MonitorRenderer.renderCompactRow(r)));
    const n = currentRecommended.length;
    $('#recommended-empty').toggleClass('tw-hidden', n > 0);
    $('#tab-count-recommended').text(n ? `(${n})` : '');
    updateDownloadLink();
  }


  function bindModePills() {
    $sentimentContainer.find('.summary-mode-pill').on('click', function() {
      const mode = $(this).data('mode');
      if (mode === $('[name=summary_type]').val()) return;
      $('[name=summary_type]').val(mode);
      // Same corpus/relevant set; only the briefing changes, so skip the triage phase.
      loadBriefing(filters.buildParams(1), { briefingOnly: true });
    });
  }

  function renderLegacySummary(summary) {
    function renderThemeBlock(title, themes) {
      return themes.length ? `
        <div class="tw-flex-1 tw-flex tw-flex-col tw-gap-2">
          <div class="tw-font-medium">${escapeHtml(title)}</div>
          <ul class="tw-list-disc tw-ps-5">
            ${themes.map(theme => `<li class="tw-mb-1">${escapeHtml(theme)}</li>`).join('')}
          </ul>
        </div>` : '';
    }

    const headingI18n = summary.heading_i18n || {};
    const sections = summary.sections.map(
        (section) => renderThemeBlock(headingI18n[section.heading] || section.heading, section.items)
    ).join('');

    return `
      ${renderCardHeader(null, summary)}
      <div class="tw-text-[22px] tw-text-primary-text">${escapeHtml(summary.title)}</div>
      <div>
        <div class="tw-text-sm tw-text-secondary-text tw-tracking-tight">${escapeHtml(summary.overview)}</div>
      </div>
      ${sections ? `
        <div class="tw-border-t tw-border-border tw-w-full"></div>
        <div class="tw-flex tw-flex-col tw-gap-4 tw-text-sm tw-text-secondary-text">
          ${sections}
        </div>` : ''}`;
  }

  function renderCoverageAnalysisCard(summary, articles, totalArticles) {
    const sections = summary.sections || [];
    const keySection = sections.find(s => /^key themes$/i.test(s.heading)) || {};
    const otherSection = sections.find(s => /^other themes$/i.test(s.heading)) || {};
    const citedByN = {};
    (summary.cited_sources || []).forEach(s => { citedByN[s.n] = s; });

    const themeColumns = ((keySection.items || []).length || (otherSection.items || []).length) ? `
      <div class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-8 tw-text-sm tw-text-primary-text tw-tracking-[-0.05em]">
        ${renderThemeColumn(window.JN.t('js.monitor.key_themes'), keySection, citedByN)}
        ${renderThemeColumn(window.JN.t('js.monitor.other_themes'), otherSection, citedByN)}
      </div>` : '';

    const narratives = summary.dominant_narratives || [];
    const stakeholders = summary.stakeholder_positions || [];
    const dataPoints = summary.key_data_points || [];
    const quotes = (summary.notable_quotes || []).filter(q => q && q.text);

    const narrativesBlock = (narratives.length || stakeholders.length) ? `
      ${renderDivider()}
      <details class="tw-group">
        <summary class="monitor-more tw-flex tw-items-center tw-gap-1.5 tw-cursor-pointer tw-text-sm tw-font-medium tw-text-brand-600 hover:tw-text-brand-700">
          <iconify-icon icon="lucide:chevron-right" class="tw-text-base tw-transition-transform group-open:tw-rotate-90"></iconify-icon>
          <span class="group-open:tw-hidden">${window.JN.t('js.monitor.show_narratives')}</span>
          <span class="tw-hidden group-open:tw-inline">${window.JN.t('js.monitor.hide_narratives')}</span>
        </summary>
        <div class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-8 tw-mt-4">
          ${narratives.length ? `
            <div class="tw-flex-1 tw-min-w-0">
              ${renderSectionHeading(window.JN.t('js.monitor.dominant_narratives'))}
              ${renderNarrativeBars(narratives, totalArticles)}
            </div>` : ''}
          ${stakeholders.length ? `
            <div class="tw-flex-1 tw-min-w-0">
              ${renderSectionHeading(window.JN.t('js.monitor.stakeholders_position'))}
              ${renderStakeholderList(stakeholders)}
            </div>` : ''}
        </div>
      </details>` : '';

    const factsQuotesRow = (dataPoints.length || quotes.length) ? `
      ${renderDivider()}
      <div class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-8">
        ${dataPoints.length ? `
          <div class="tw-flex-1 tw-min-w-0">
            ${renderSectionHeading(window.JN.t('js.monitor.key_data_points'))}
            ${renderKeyDataPoints(dataPoints)}
          </div>` : ''}
        ${quotes.length ? `
          <div class="tw-flex-1 tw-min-w-0">
            ${renderSectionHeading(window.JN.t('js.monitor.notable_quotes'))}
            ${renderNotableQuotes(quotes)}
          </div>` : ''}
      </div>` : '';

    return `
      ${renderCardHeader(summary.headline, summary)}
      <div class="tw-text-[22px] tw-text-primary-text tw-leading-tight tw-tracking-[-0.05em]">${escapeHtml(summary.overview)}</div>
      ${themeColumns ? `${renderDivider()}${themeColumns}` : ''}
      ${factsQuotesRow}
      ${narrativesBlock}`;
  }

  function renderDivider() {
    return '<div class="tw-border-t tw-border-border tw-w-full"></div>';
  }

  function renderSectionHeading(text) {
    return `<div class="tw-font-medium tw-text-sm tw-text-secondary-text tw-tracking-[-0.05em] tw-mb-2">${escapeHtml(text)}</div>`;
  }

  function renderCardHeader(headline, summary, opts) {
    opts = opts || {};
    const curType = $('[name=summary_type]').val();
    const label = headline || SUMMARY_TYPE_LABELS[curType] || window.JN.t('js.monitor.mode_coverage_analysis');
    const meta = summary ? renderSummaryMeta(summary) : '';
    const menuItems = SUMMARY_TYPE_MODES.map(([value, text]) => {
      const active = value === curType;
      return `<button type="button" class="summary-mode-pill tw-block tw-w-full tw-text-start tw-px-4 tw-py-2 tw-text-sm hover:tw-bg-grey ${active ? 'tw-text-brand-700 tw-font-medium' : 'tw-text-primary-text'}" data-mode="${value}">${text}</button>`;
    }).join('');
    const actions = opts.hideActions ? '' : `
      <div class="tw-flex tw-items-center tw-gap-2 tw-shrink-0">
        <button type="button" onclick="$('#add-alert')[0].showModal();" class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-bg-brand-600 hover:tw-bg-brand-700 tw-text-white tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-whitespace-nowrap tw-transition-colors">
          <iconify-icon icon="lucide:mail" class="tw-text-base tw-align-middle"></iconify-icon>
          <span class="tw-hidden md:tw-inline">${window.JN.t('js.monitor.get_this_daily')}</span>
        </button>
        <button type="button" onclick="$('#send-summary')[0].showModal();" title="${window.JN.t('js.monitor.send_to_friend')}" class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-border-border tw-bg-white tw-text-secondary-text hover:tw-text-primary-text hover:tw-border-tertiary tw-px-4 tw-py-2 tw-text-sm tw-whitespace-nowrap tw-transition-colors">
          <iconify-icon icon="lucide:share" class="tw-text-base tw-align-middle"></iconify-icon>
          <span class="tw-hidden md:tw-inline">${window.JN.t('js.monitor.send')}</span>
        </button>
      </div>`;
    return `
      <div class="tw-bg-brand-50 -tw-mt-3 -tw-mx-4 md:-tw-mx-8 tw-px-4 md:tw-px-8 tw-py-3 tw-flex tw-items-start tw-justify-between tw-gap-2">
        <div class="tw-min-w-0 tw-flex-1">
          <div class="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
            <iconify-icon icon="humbleicons:ai" class="tw-text-2xl tw-text-brand-600 tw-shrink-0"></iconify-icon>
            <div class="tw-relative tw-min-w-0">
              <button type="button" id="card-type-trigger" class="tw-flex tw-items-center tw-gap-1 tw-min-w-0 tw-max-w-full">
                <span class="tw-font-normal tw-text-lg tw-leading-[26px] tw-tracking-[-0.05em] tw-truncate">${escapeHtml(label)}</span>
                <iconify-icon icon="lucide:chevron-down" class="tw-text-base tw-text-tertiary tw-shrink-0"></iconify-icon>
              </button>
              <div id="card-type-menu" class="tw-hidden tw-absolute tw-start-0 tw-top-full tw-mt-1 tw-w-56 tw-bg-white tw-rounded-xl tw-border tw-border-border tw-shadow-lg tw-z-20 tw-py-1">
                <div class="tw-px-4 tw-py-1 tw-text-xs tw-text-tertiary">${window.JN.t('js.monitor.analysis_type')}</div>
                ${menuItems}
              </div>
            </div>
          </div>
          ${meta ? `<div class="tw-mt-1 md:tw-ps-9">${meta}</div>` : ''}
        </div>
        ${actions}
      </div>`;
  }

  function bindCardHeader() {
    const $menu = $('#card-type-menu');
    $('#card-type-trigger').off('click').on('click', function(e) {
      e.stopPropagation();
      $menu.toggleClass('tw-hidden');
    });
    $(document).off('click.cardmenu').on('click.cardmenu', function(e) {
      if (!$(e.target).closest('#card-type-menu, #card-type-trigger').length) $menu.addClass('tw-hidden');
    });
    bindModePills();
  }


  function aiNote(text) {
    return `
      <div class="tw-flex tw-items-start tw-gap-1 tw-mt-2 tw-text-xs tw-text-secondary-text tw-italic">
        <iconify-icon icon="humbleicons:ai" class="tw-text-sm tw-text-brand-600 tw-shrink-0"></iconify-icon>
        <span>${escapeHtml(text)}</span>
      </div>`;
  }

  function glanceCard(label, body, noteId) {
    return `
      <div class="tw-border tw-border-border tw-rounded-xl tw-p-3">
        <div class="tw-text-xs tw-font-medium tw-text-secondary-text">${escapeHtml(label)}</div>
        <div class="tw-mt-2">${body}</div>
        <div id="${noteId}" class="glance-note"></div>
      </div>`;
  }

  const SENTIMENT_COLORS = { positive: '#05968d', neutral: '#BDC2CF', negative: '#bb2b29' };

  function glanceWindow(dataset) {
    // Pin the x-axis to the searched window (allWindow) so all three tabs share one axis
    // and the chart shows where coverage occurred AND where there was none. Falls back to
    // the data's own range only when the searched window is unknown.
    if (allWindow && allWindow.max > allWindow.min) return allWindow;
    const ds = (dataset.points || []).map(p => p.d).filter(Boolean);
    if (ds.length < 2) return null;
    return { min: Math.min(...ds), max: Math.max(...ds) };
  }

  function windowDatesLabel(win) {
    if (!win) return '';
    const f = t => { const d = new Date(t * 1000); return `${d.getDate()} ${d.toLocaleString('en', { month: 'short' })}`; };
    const a = f(win.min), b = f(win.max);
    return a === b ? a : `${a} ${window.JN.t('js.monitor.date_range_to')} ${b}`;
  }

  function fmtBinLabel(epochSec, spanDays) {
    const dt = new Date(epochSec * 1000);
    const day = dt.getDate();
    const mon = dt.toLocaleString('en', { month: 'short' });
    if (spanDays <= 2) return `${day} ${mon} ${String(dt.getHours()).padStart(2, '0')}:00`;
    return `${day} ${mon}`;
  }

  function buildSeries(dataset, win) {
    const BINS = 8;
    const span = Math.max(win.max - win.min, 1);
    const spanDays = span / 86400;
    const labels = [], idx = {};
    for (let i = 0; i < BINS; i++) {
      const t = win.min + (span * i) / BINS;
      labels.push(fmtBinLabel(t, spanDays));
    }
    const series = { positive: new Array(BINS).fill(0), neutral: new Array(BINS).fill(0), negative: new Array(BINS).fill(0) };
    (dataset.points || []).forEach(p => {
      const b = Math.min(BINS - 1, Math.max(0, Math.floor(((p.d - win.min) / span) * BINS)));
      (series[p.s] || series.neutral)[b]++;
    });
    return { labels, series };
  }

  function renderGlanceChart(dataset) {
    if (glanceChart) { glanceChart.destroy(); glanceChart = null; }
    const canvas = document.getElementById('glance-chart');
    const win = glanceWindow(dataset);
    if (!canvas || !win || typeof Chart === 'undefined') return;
    const { labels, series } = buildSeries(dataset, win);
    const ds = (label, key) => ({
      label, data: series[key], borderColor: SENTIMENT_COLORS[key],
      backgroundColor: SENTIMENT_COLORS[key], tension: 0.35, borderWidth: 2,
      pointRadius: 0, pointHoverRadius: 4, fill: false,
    });
    glanceChart = new Chart(canvas, {
      type: 'line',
      data: { labels, datasets: [ds(window.JN.t('js.monitor.sentiment_positive'), 'positive'), ds(window.JN.t('js.monitor.sentiment_neutral'), 'neutral'), ds(window.JN.t('js.monitor.sentiment_negative'), 'negative')] },
      options: {
        responsive: true, maintainAspectRatio: false, interaction: { mode: 'index', intersect: false },
        plugins: {
          legend: { position: 'bottom', labels: { boxWidth: 8, boxHeight: 8, usePointStyle: true, font: { size: 11 }, color: '#6b6b6b' } },
          tooltip: { enabled: true },
        },
        scales: {
          x: { grid: { display: false }, ticks: { maxTicksLimit: 6, maxRotation: 0, autoSkip: true, font: { size: 11 }, color: '#9b9b9b' } },
          y: { beginAtZero: true, ticks: { precision: 0, maxTicksLimit: 4, font: { size: 11 }, color: '#9b9b9b' }, grid: { color: '#f0f0f0' } },
        },
      },
    });
  }

  function renderGlanceStrip(dataset) {
    const stats = dataset.stats || {};
    const sources = {};
    let sampleN = 0;
    Object.keys(SENTIMENT_COLORS).forEach(s => {
      Object.entries(stats[s] || {}).forEach(([name, n]) => {
        sampleN += n;
        sources[name] = (sources[name] || 0) + n;
      });
    });
    if (!sampleN) return '';

    const chartCard = `
      <div class="md:tw-col-span-2 tw-border tw-border-border tw-rounded-xl tw-p-3">
        <div class="tw-flex tw-items-baseline tw-justify-between tw-gap-2">
          <div class="tw-text-xs tw-font-medium tw-text-secondary-text">${window.JN.t('js.monitor.coverage_volume')}</div>
          <div class="tw-text-xs tw-text-tertiary">${window.JN.t('js.monitor.n_articles').replace('%s', dataset.count || sampleN)} · ${escapeHtml(windowDatesLabel(glanceWindow(dataset)) || currentDateRangeLabel())}</div>
        </div>
        <div class="tw-mt-2" style="height:150px"><canvas id="glance-chart"></canvas></div>
        <div id="note-chart" class="glance-note"></div>
        <div class="tw-mt-1 tw-text-end">
          <button type="button" id="glance-expand" class="tw-text-xs tw-text-brand-600 hover:tw-underline">${window.JN.t('js.monitor.widen_time_range')}</button>
        </div>
      </div>`;

    const top = Object.entries(sources).sort((a, b) => b[1] - a[1]).slice(0, 5);
    const outletRows = top.map(([name, n]) => {
      const id = sourceIdByName[name];
      const nameCell = id
        ? `<span class="outlet-filter tw-truncate tw-text-brand-600 tw-cursor-pointer hover:tw-underline" data-source-id="${escapeAttr(id)}" data-source-name="${escapeAttr(name)}">${escapeHtml(name)}</span>`
        : `<span class="tw-truncate">${escapeHtml(name)}</span>`;
      return `<div class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-text-sm tw-py-0.5">
        ${nameCell}<span class="tw-text-tertiary">${n}</span>
      </div>`;
    }).join('');
    const outletCard = glanceCard(window.JN.t('js.monitor.top_outlets'), outletRows, 'note-outlets');

    return `<div class="tw-grid md:tw-grid-cols-3 tw-gap-3">${chartCard}${outletCard}</div>`;
  }

  function renderNotableQuotes(quotes) {
    return `
      <div class="tw-flex tw-flex-col tw-gap-4 tw-tracking-[-0.05em]">
        ${quotes.map(q => {
          const attribution = q.attribution ? `— ${escapeHtml(q.attribution)}` : '';
          const link = q.article_url
            ? `<a href="${escapeAttr(q.article_url)}" target="_blank" rel="noopener" class="tw-text-brand-600 tw-font-normal tw-ms-2 tw-whitespace-nowrap">${window.JN.t('js.monitor.read_article')}</a>`
            : '';
          return `
            <div class="tw-flex tw-gap-3 tw-items-start">
              <iconify-icon icon="mingcute:quote-left-fill" class="tw-text-[22px] tw-text-brand-200 tw-shrink-0 tw-mt-1"></iconify-icon>
              <div class="tw-flex-1 tw-min-w-0">
                <div class="tw-text-sm tw-italic tw-text-primary-text tw-leading-snug">${escapeHtml(q.text)}</div>
                <div class="tw-text-xs tw-text-secondary-text tw-leading-tight tw-mt-1">${attribution}${link}</div>
              </div>
            </div>`;
        }).join('')}
      </div>`;
  }

  function renderKeyDataPoints(points) {
    return `
      <div class="tw-flex tw-flex-col tw-gap-4 tw-text-sm tw-tracking-[-0.05em]">
        ${points.map(p => {
          const link = p.article_url
            ? `<a href="${escapeAttr(p.article_url)}" target="_blank" rel="noopener" class="tw-text-brand-600 tw-font-normal tw-whitespace-nowrap">${window.JN.t('js.monitor.source_link')}</a>`
            : '';
          return `
            <div class="tw-flex tw-gap-2 tw-items-start">
              <iconify-icon icon="lucide:check-circle" class="tw-text-base tw-text-accent-green tw-shrink-0 tw-mt-1"></iconify-icon>
              <div class="tw-flex-1 tw-min-w-0">
                <div class="tw-text-primary-text tw-leading-snug">${escapeHtml(p.fact)}</div>
                <div class="tw-text-xs tw-text-secondary-text tw-leading-tight tw-mt-1">
                  ${p.attribution ? escapeHtml(p.attribution) : ''}
                  ${link ? ` · ${link}` : ''}
                </div>
              </div>
            </div>`;
        }).join('')}
      </div>`;
  }

  function renderThemeColumn(title, section, citedByN) {
    const themes = (section && section.items) || [];
    if (!themes.length) return '';
    const sourceNs = (section && section.source_ns) || [];
    return `
      <div class="tw-flex-1 tw-flex tw-flex-col tw-gap-3">
        <div class="tw-font-medium tw-text-sm tw-text-secondary-text tw-tracking-[-0.05em]">${escapeHtml(title)}</div>
        <ul class="tw-list-disc tw-ps-5 tw-leading-snug">
          ${themes.map((t, i) => `<li class="tw-mb-2">${escapeHtml(t)}${renderThemeSources(sourceNs[i], citedByN)}</li>`).join('')}
        </ul>
      </div>`;
  }

  // Footnote links after a theme: `[1] [2]` opening the source article in the in-page
  // reader. Carries the url/title on the anchor so the delegated click handler needs no
  // lookup; cmd/ctrl-click falls through to open the original in a new tab.
  function renderThemeSources(ns, citedByN) {
    if (!ns || !ns.length) return '';
    const links = ns.map(n => {
      const src = citedByN[n];
      if (!src) return '';
      if (!/^https?:\/\//i.test(src.url || '')) return `<span class="theme-source">[${n}]</span>`;
      return `<a class="theme-source !tw-text-brand-600 hover:!tw-text-brand-700 !tw-no-underline tw-cursor-pointer" href="${escapeAttr(src.url)}" target="_blank" rel="noopener" title="${escapeAttr(src.title || '')}">[${n}]</a>`;
    }).filter(Boolean).join('<span class="tw-text-tertiary"> </span>');
    return links ? ` <sup class="tw-text-[11px] tw-font-medium tw-whitespace-nowrap tw-top-[-0.4em]">${links}</sup>` : '';
  }

  function renderNarrativeBars(narratives, totalArticles) {
    const denom = Math.max(totalArticles || 0, 1);
    const rows = narratives
      .map(n => ({ label: n.label, count: (n.article_urls || []).length }))
      .sort((a, b) => b.count - a.count);
    const maxDots = 15;
    return `
      <div class="tw-flex tw-flex-col tw-gap-2 tw-text-sm">
        ${rows.map(r => {
          const pct = Math.round((r.count / denom) * 100);
          const dots = Math.max(1, Math.min(maxDots, Math.ceil(pct / 3)));
          const cells = [];
          for (let i = 0; i < dots; i++) {
            cells.push('<span class="tw-inline-block tw-w-2 tw-h-5 tw-rounded-full" style="background-color: #BDC2CF"></span>');
          }
          return `
            <div class="tw-grid tw-grid-cols-[minmax(0,1fr)_auto_2.5rem] tw-items-center tw-gap-3 tw-tracking-[-0.05em]">
              <div class="tw-text-primary-text tw-truncate" title="${escapeAttr(r.label)}">${escapeHtml(r.label)}</div>
              <div class="tw-flex tw-gap-1 tw-justify-end">${cells.join('')}</div>
              <div class="tw-text-end tw-text-primary-text">${pct}%</div>
            </div>`;
        }).join('')}
      </div>`;
  }

  function renderStakeholderList(stakeholders) {
    return `
      <div class="tw-flex tw-flex-col tw-gap-3 tw-text-sm tw-tracking-[-0.05em]">
        ${stakeholders.map(s => `
          <div class="tw-flex tw-flex-col md:tw-flex-row md:tw-items-start md:tw-justify-between tw-gap-1 md:tw-gap-4">
            <div class="tw-text-primary-text tw-font-normal md:tw-shrink-0">${escapeHtml(s.name)}</div>
            <div class="tw-text-primary-text md:tw-text-end tw-leading-snug">${escapeHtml(s.stance_summary)}</div>
          </div>`).join('')}
      </div>`;
  }


  function currentDateRangeLabel() {
    const checked = $('.quickdate :radio:checked');
    if (checked.length && checked.val() === 'auto') {
      return summaryStats.windowLabel || window.JN.t('js.monitor.auto');
    }
    if (checked.length && checked.val() !== 'custom') {
      return $(`label[for="${checked.attr('id')}"]`).text().trim();
    }
    const from = $('#from_date').val();
    const to = $('#to_date').val();
    if (from && to) return `${from} ${window.JN.t('js.monitor.date_range_to')} ${to}`;
    if (from) return window.JN.t('js.monitor.since').replace('%s', from);
    return window.JN.t('js.monitor.latest_coverage');
  }

  function renderSummaryMeta(summary) {
    const rel = summaryStats.relevant || 0;
    const found = summaryStats.found || summaryStats.corpus || 0;
    const articleWord = found === 1 ? window.JN.t('js.monitor.article_one') : window.JN.t('js.monitor.article_many');
    const label = (rel && found)
      ? `${window.JN.t('js.monitor.meta_found').replace('%n', found).replace('%w', articleWord)} · ${window.JN.t('js.monitor.meta_relevant').replace('%s', rel)} · ${escapeHtml(currentDateRangeLabel())}`
      : `${escapeHtml(currentDateRangeLabel())}`;
    return `<div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap tw-text-xs tw-text-tertiary">
      <span>${label}</span>
    </div>`;
  }

  let lastSearchPlan = null;

  // Stages are driven by real events now (search → triage → briefing), not timers.
  function stopSummaryStages() {}

  function setSummaryStage(active) {
    // keep tw-text-sm on every branch so a stage doesn't change size when it activates/completes
    $sentimentContainer.find('.summary-stage').each(function(idx) {
      const $icon = $(this).find('iconify-icon');
      if (idx < active) {
        $icon.attr('icon', 'lucide:check-circle').attr('class', 'tw-text-accent-green');
        this.className = 'summary-stage tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-secondary-text';
      } else if (idx === active) {
        $icon.attr('icon', 'svg-spinners:90-ring-with-bg').attr('class', 'tw-text-brand-600');
        this.className = 'summary-stage tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-primary-text';
      } else {
        $icon.attr('icon', 'lucide:circle').attr('class', 'tw-text-tertiary');
        this.className = 'summary-stage tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-tertiary';
      }
    });
  }

  // The date range is the first stage: it spins until the backend has chosen the window,
  // then the triage and briefing phases advance the rest (event-driven, no timers).
  function dateRangeKnown() {
    return !$('#days-auto').prop('checked') || !!lastSearchPlan;
  }

  function startSummaryStages() {
    // Date range done (explicit date or plan already in) -> spin Scanning; else spin Date range.
    setSummaryStage(dateRangeKnown() ? 1 : 0);
  }

  // Label for the first stage: spins as "Setting the date range" until the backend picks the
  // window, then resolves to e.g. "Date range: last 28 days" (the chosen Best match).
  function dateRangeStageLabel() {
    if (!$('#days-auto').prop('checked')) return window.JN.t('js.monitor.date_range_label').replace('%s', currentDateRangeLabel());
    if (lastSearchPlan) return window.JN.t('js.monitor.date_range_label').replace('%s', planWindowLabel(lastSearchPlan));
    return window.JN.t('js.monitor.setting_date_range');
  }

  function renderLoadingState() {
    // Date range is the first of four stages, resolved first (by the backend), then the rest.
    const stages = [dateRangeStageLabel(), window.JN.t('js.monitor.stage_scanning'), window.JN.t('js.monitor.stage_finding'), window.JN.t('js.monitor.stage_writing')];
    const rows = stages.map(s => `
      <div class="summary-stage tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-tertiary">
        <iconify-icon icon="lucide:circle" class="tw-text-tertiary"></iconify-icon>
        <span>${escapeHtml(s)}</span>
      </div>`).join('');
    return `
      ${renderCardHeader()}
      <div class="tw-flex tw-flex-col tw-gap-2 tw-py-2">${rows}</div>
      <div class="tw-text-xs tw-text-tertiary">${window.JN.t('js.monitor.loading_timing')}</div>`;
  }

  function emptyBtn(action, label, icon, primary) {
    const cls = primary
      ? 'tw-bg-brand-600 hover:tw-bg-brand-700 tw-text-white tw-font-medium'
      : 'tw-border tw-border-border tw-bg-white tw-text-secondary-text hover:tw-text-primary-text';
    const ic = icon ? `<iconify-icon icon="${icon}" class="tw-text-base tw-align-middle"></iconify-icon> ` : '';
    return `<button type="button" data-empty="${action}" class="empty-action tw-rounded-full tw-px-4 tw-py-2 tw-text-sm ${cls}">${ic}${label}</button>`;
  }

  function renderEmptyState(summary) {
    const reason = (summary && summary.reason) || '';
    const isNetwork = /reach|network/i.test(reason);
    const rel = summaryStats.relevant || 0;
    const n = summaryStats.found || foundArticles || 0;
    const win = currentDateRangeLabel();

    let icon = 'lucide:telescope', heading, help, actions;
    if (isNetwork) {
      icon = 'lucide:wifi-off';
      heading = window.JN.t('js.monitor.empty_network_heading');
      help = window.JN.t('js.monitor.empty_network_help');
      actions = emptyBtn('retry', window.JN.t('js.monitor.btn_try_again'), '', true);
    } else if (rel > 0) {
      // Triage succeeded; only the written briefing didn't generate. The charts and
      // article list below are valid, so this is a soft, recoverable state.
      icon = 'lucide:sparkles';
      heading = window.JN.t('js.monitor.empty_briefing_heading');
      const relWord = rel === 1 ? window.JN.t('js.monitor.article_one') : window.JN.t('js.monitor.article_many');
      help = window.JN.t('js.monitor.empty_briefing_help').replace('%n', rel).replace('%w', relWord);
      actions = emptyBtn('retry', window.JN.t('js.monitor.btn_write_again'), 'lucide:refresh-cw', true);
    } else {
      const topic = escapeHtml(filters.getValues().q || window.JN.t('js.monitor.this_topic'));
      heading = window.JN.t('js.monitor.empty_nothing_heading').replace('%s', topic);
      const nWord = n === 1 ? window.JN.t('js.monitor.article_one') : window.JN.t('js.monitor.article_many');
      help = window.JN.t('js.monitor.empty_nothing_help').replace('%n', n).replace('%w', nWord).replace('%d', escapeHtml(win));
      actions = emptyBtn('widen', window.JN.t('js.monitor.btn_widen_dates'), 'lucide:calendar-plus', true)
        + ($('select[name=country]').val() ? emptyBtn('anycountry', window.JN.t('js.monitor.btn_any_country'), 'lucide:globe', false) : '')
        + (n ? emptyBtn('seeall', window.JN.t('js.monitor.btn_see_all').replace('%s', n), '', false) : '');
    }

    return `
      ${renderCardHeader(null, null, { hideActions: true })}
      <div class="empty-state">
        <iconify-icon icon="${icon}" class="empty-state-icon" aria-hidden="true"></iconify-icon>
        <div class="tw-text-lg tw-text-primary-text">${heading}</div>
        <p class="empty-state-text">${help}</p>
        <div class="tw-flex tw-items-center tw-justify-center tw-flex-wrap tw-gap-2 tw-mt-3">${actions}</div>
      </div>`;
  }

  function escapeAttr(s) {
    return String(s == null ? '' : s).replace(/"/g, '&quot;');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ============================================================================
  // Search Triggers
  // ============================================================================

  function parseQuery(q) {
    const regex = /[^\s"]+:"[^"]+"|"[^"]+"|\S+/g;
    const result = [];
    let match;
    while ((match = regex.exec(q)) !== null) {
      result.push(match[0].replaceAll('"', ''));
    }
    return result;
  }

  // ============================================================================
  // Search History
  // ============================================================================

  function addSearchToHistory() {
    $('#last_searches').show();
    const historyItems = $('#last_searches span');
    const searchString = filters.getValues().q;
    const searchLower = searchString.toLowerCase().trim();

    if (!historyItems.filter((i, item) => item.textContent.toLowerCase().trim() === searchLower).length) {
      if (historyItems.length > 3) {
        $(historyItems[3]).remove();
      }
      $(historyItems[0]).clone().text(searchString).prependTo($('#last_searches'));
    }
  }

  // ============================================================================
  // Event Handlers
  // ============================================================================

  // Quick date selection
  $('.quickdate :radio:not([value=custom])').on('change', function() {
    $('.date-range').addClass('tw-hidden');
    // "Best match" = no client date constraint; the server progressively widens
    // the window until it finds coverage (24h → 7d → 28d).
    if ($(this).val() === 'auto') {
      $('#from_date').datepicker('setDate', null);
      $('#to_date').datepicker('setDate', null);
      return;
    }
    $('#date-auto-note').addClass('tw-hidden');
    const days = parseInt($(this).val());
    const fromDate = new Date();
    fromDate.setHours(0, 0, 0, 0);
    fromDate.setDate(fromDate.getDate() - days);
    $('#from_date').datepicker('setDate', fromDate);
    $('#to_date').datepicker('setDate', null);
  });

  $('.quickdate :radio[value=custom]').on('change', function() {
    $('.date-range').removeClass('tw-hidden');
  });

  // Switching tabs: remember the user chose, and update the glance charts to that set.
  $('#results-tabs input[name=rtabs]').on('change', function() {
    resultsTabsTouched = true;
    renderGlanceFor(currentResultsTab());
    updateDownloadLink();
  });

  // Download CSV for the active tab. All and Relevant stream server-side from the cached corpus /
  // triaged set (full sets, no extra NewsAPI call); Recommended is small and already complete in
  // memory, so it stays a client-side build.
  $('#download-csv').on('click', function(e) {
    e.preventDefault();
    const tab = currentResultsTab();
    if (tab === 'recommended') {
      downloadClientCsv(currentRecommended);
    } else {
      const form = document.getElementById('csv-form');
      form.querySelector('[name=tab]').value = tab;   // 'all' or 'relevant'
      form.submit();
    }
  });

  $('.dates-clear').on('click', function() {
    updateDateControls(null, null);
  });

  // Select styling
  $('#search-form select').on('change', function() {
    const $select = $(this);
    if ($select.val() === '') {
      $select.addClass('tw-text-tertiary').removeClass('tw-text-primary-text');
    } else {
      $select.addClass('tw-text-primary-text').removeClass('tw-text-tertiary');
    }
  }).change();

  $('#first-run [data-example-q]').on('click', function() {
    $('#search-form input[name=q]').val($(this).data('example-q'));
    const mode = $(this).data('example-mode');
    if (mode) {
      $('[name=summary_type]').val(mode);
    }
    $('#search-form').submit();
  });

  // Clear source when country, language, or rank is selected (mutually exclusive)
  $('select[name=country], select[name=language], select[name=rank]').on('change', function() {
    if ($(this).val()) {
      sourceSearch.clear();
    }
  });

  // Reset filters
  $('#reset-filter_button').click(function() {
    const values = filters.getValues();
    const currentSource = values.source;
    const searchString = values.q;
    filters.reset(sourceSearch);
    if (JSON.stringify(values) === JSON.stringify(filters.getValues())) {
      return
    }
    initSearch();
    doSearch();
  });

  // Apply filters
  function applyFilters(e) {
    if (e) e.preventDefault();
    if ($(`#days-custom`).prop('checked') && !$('#to_date').val()) {
      $('#to_date').datepicker('setDate', new Date());
    }

    initSearch();
    doSearch();
    return false;
  }

  // "Widen the time range" from the chart: step out to the next coarser window and re-search.
  function expandRange() {
    const pill = $('.quickdate :radio:checked').val();
    const curDays = { '1': 1, '7': 7, '28': 28, custom: 999,
      auto: allWindow ? (allWindow.max - allWindow.min) / 86400 : 1 }[pill] ?? 1;
    const next = [7, 28, 90, 365].find(t => t > curDays + 0.5) || 365;
    const from = new Date(); from.setHours(0, 0, 0, 0); from.setDate(from.getDate() - next);
    $('#days-auto, #days-1, #days-7, #days-28, #days-custom').prop('checked', false);
    if (next === 7) $('#days-7').prop('checked', true);
    else if (next === 28) $('#days-28').prop('checked', true);
    else $('#days-custom').prop('checked', true);
    $('#date-auto-note').addClass('tw-hidden');
    $('.date-range').addClass('tw-hidden');
    $('#from_date').datepicker('setDate', from);
    $('#to_date').datepicker('setDate', null);
    applyFilters();
  }

  // Clear filters
  $('#clear-filters').on('click', function() {
    $('#filters').find('select').prop('selectedIndex', 0);
  });

  // Infinite scroll (only the All results tab paginates the chronological corpus)
  $(window).on('scroll', () => {
    if (!$('#rtab-all').prop('checked')) return;
    const bottom = $resultsContainer[0].getBoundingClientRect().bottom;
    if (bottom < window.innerHeight + 150 && !isLoading && !stopSearch) {
      doSearch();
    }
  });

  // Search history clicks
  $('#last_searches span').on('click', function() {
    $('input[name=q]').val($(this).text());
    $('#search-form').submit();
  });

  // Modal handlers
  $('dialog .close-modal').on('click', function() {
    $(this).closest('dialog')[0].close();
  });

  $('#add-alert form').on('submit', function() {
    $(this).find('[type=submit]')
      .prop('disabled', true)
      .html('<iconify-icon icon="svg-spinners:90-ring-with-bg"></iconify-icon>');
  });

  $('#send-summary-form').on('submit', function(e) {
    e.preventDefault();
    const $btn = $('#send-summary-btn');
    const $error = $('#send-summary-error');
    $error.addClass('tw-hidden').text('');
    $btn.prop('disabled', true).html('<iconify-icon icon="svg-spinners:90-ring-with-bg"></iconify-icon>');

    const formData = new URLSearchParams({
      email: $(this).find('[name=email]').val(),
      note_tx: $(this).find('[name=note_tx]').val(),
    });

    window.JN.xsrf.fetch('/monitor/share?' + filters.buildParams().toString(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formData.toString(),
    })
      .then(async (response) => {
        const result = await response.json();
        if (response.ok) {
          $('#send-summary')[0].close();
          $('#send-summary-form')[0].reset();
        } else {
          $error.text(result.message || window.JN.t('js.monitor.error_generic')).removeClass('tw-hidden');
        }
      })
      .catch(() => {
        $error.text(window.JN.t('js.monitor.error_generic')).removeClass('tw-hidden');
      })
      .finally(() => {
        $btn.prop('disabled', false).text(window.JN.t('js.monitor.send'));
      });
  });

  // ============================================================================
  // Initialization
  // ============================================================================

  // Initialize dates from URL
  initializeDatesFromUrl();

  // Back/forward steps between the pushState'd search URLs. Reload to restore that
  // exact state deterministically (the page re-runs the search from the URL params)
  // rather than leaving a half-synced view.
  window.addEventListener('popstate', function() {
    if (window.JN.workModal && window.JN.workModal.ownsHistory()) return;
    window.location.reload();
  });

  // Adjust footer spacing
  setTimeout(() => {
    const $footer = $('footer');
    const footerTop = $footer.offset()?.top || 0;
    const footerHeight = $footer.outerHeight() || 0;
    $resultsContainer.css('min-height', `${window.innerHeight - footerTop - footerHeight - 30}px`);
  }, 1);

  $('#search-form').on('submit', applyFilters);
  if (typeof gateBlocked !== 'undefined' && gateBlocked) {
    // Over the daily limit already: show the signup gate on load instead of running a
    // search the server would just reject.
    handleDailyLimitExceeded();
  } else {
    if (!anonymous && !filters.getValues().q) {
      const saved = loadResume();
      if (saved && saved.q) renderResumeChip(saved);
    }
    $('#search-form').submit();
  }
}

// Expose to global so esbuild bundles (entries/monitor.js) and template inline
// scripts (dashboard.html uses MonitorRenderer; monitor.html calls onPageLoad)
// reach the same symbol whether loaded as <script src> or via the bundle.
window.MonitorRenderer = MonitorRenderer;
window.monitorPageLoad = onPageLoad;
